import React, { useMemo, useState } from "react";
import AssessmentCard from "./AssessmentCard";
import AssessmentPagination from "./AssessmentPagination";
import "./AssessShared.css";

export default function AssessSectionList({
  activeTab,
  items,
  // searchPlaceholder = "Search by keyword",
  onView,
  onEdit,
  onDelete,
  onSetup,
  onPublish,
  onCancelPublish,
  // showToolbar = true,
  page = 1,
  pageSize = 20,
  totalCount = 0,
  onPageChange = () => {},
  onPageSizeChange = () => {},
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");

  const filteredItems = useMemo(() => {
    // if (!showToolbar) {
    //   return items;
    // }

    const normalizedSearch = searchTerm.trim().toLowerCase();

    return [...items]
      .filter((item) => {
        if (!normalizedSearch) return true;
        return [item.name, item.status, item.owner]
          .join(" ")
          .toLowerCase()
          .includes(normalizedSearch);
      })
      .sort((a, b) => {
        const firstDate = new Date(a.createdAt).getTime();
        const secondDate = new Date(b.createdAt).getTime();
        return sortDirection === "desc"
          ? secondDate - firstDate
          : firstDate - secondDate;
      });
  }, [items, searchTerm, sortDirection]);

  return (
    <>
      {/* {showToolbar && (
        <div className="assess-toolbar">
          <div className="assess-search">
            <input
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
            />
          </div>

          <div className="assess-toolbar__meta">
            <span>{filteredItems.length} total</span>
            <select
              value={sortDirection}
              onChange={(event) => setSortDirection(event.target.value)}
              aria-label="Sort by created date"
            >
              <option value="desc">Newest created</option>
              <option value="asc">Oldest created</option>
            </select>
          </div>
        </div>
      )} */}

      <div className="assess-card-list">
        {filteredItems.map((item) => (
          <AssessmentCard
            activeTab={activeTab}
            key={item.id}
            item={item}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            onSetup={onSetup}
            onPublish={onPublish}
            onCancelPublish={onCancelPublish}
          />
        ))}
      </div>

      <AssessmentPagination
        page={page}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </>
  );
}
